import React from 'react'

const DeleteIcon = () => {
  return (
   <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 6.48C17.67 6.15 14.32 5.98 10.98 5.98C9 5.98 7.02 6.08 5.04 6.28L3 6.48M8.5 5.47L8.72 4.16C8.88 3.21 9 2.5 10.69 2.5H13.31C15 2.5 15.13 3.25 15.28 4.17L15.5 5.47M18.85 9.64L18.2 19.71C18.09 21.28 18 22.5 15.21 22.5H8.79C6 22.5 5.91 21.28 5.8 19.71L5.15 9.64M10.33 17H13.66M9.5 13H14.5" stroke="#FF0E56" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  )
}

export default DeleteIcon
